import { getAffiliations } from "@/api/affiliation.service";

export const useAffiliationSearch = () => {
  return {
    itemTitle: i => i.name,
    comparisonValue: v => v.id,
    fetchResults: search => getAffiliations({ q: search })
  };
};
